import retakingHistory from '@/components/features/graduate-work-retaking-history/index.vue';

export default {
    name: 'graduate-work-question',
    components: {
        retakingHistory
    },
    props: {
        item: {}
    },
    data() {
        return {
            text: ''
        }
    },
    methods: {
        handleInput() {
            this.$emit('update-question', this.text)
        }
    },
    destroyed() {
        this.$emit('update-question', '')
    }
};
